<template>
  <div class="plan-detail-container">
    <!-- 页头 -->
    <div class="page-header">
      <div class="header-left">
        <el-button icon="el-icon-back" type="primary" @click="$router.go(-1)">返回</el-button>
        <span class="title" >采购计划详情</span>
      </div>
    </div>

    <!-- 详情内容 -->
    <el-card v-loading="loading">
      <!-- 基本信息 -->
      <div class="detail-section">
        <h3 class="section-title">基本信息</h3>
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="info-item">
              <span class="label">计划编号：</span>
              <span class="value">{{ plan?.planNo }}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="info-item">
              <span class="label">创建时间：</span>
              <span class="value">{{ formatDateTime(plan?.createdAt) }}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="info-item">
              <span class="label">状态：</span>
              <el-tag :type="getStatusType(plan?.status)">
                {{ getStatusText(plan?.status) }}
              </el-tag>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="info-item">
              <span class="label">总金额：</span>
              <span class="value" style="color: #f56c6c; font-weight: 500;">¥{{ totalMoney }}</span>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 商品信息 -->
      <div class="detail-section">
        <h3 class="section-title">商品信息</h3>
        <el-table :data="[details]" border style="width: 100%" v-if="details"
          :show-summary="true"
          :summary-method="getSummaries">
          <el-table-column prop="supplierName" label="供应商名称" width="180" align="center"></el-table-column>
          <el-table-column prop="goodName" label="商品名称" align="center"></el-table-column>
          <el-table-column prop="goodSpecs" label="规格" align="center"></el-table-column>
          <el-table-column prop="goodModel" label="型号" align="center"></el-table-column>
          <el-table-column prop="price" label="单价" width="100" align="center">
            <template slot-scope="scope">
              ¥{{ scope.row.price }}
            </template>
          </el-table-column>
          <el-table-column prop="number" label="数量" width="100" align="center"></el-table-column>
          <el-table-column prop="money" label="金额" width="100" align="center">
            <template slot-scope="scope">
              ¥{{ scope.row.money }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 供应商信息 -->
      <div class="detail-section">
        <h3 class="section-title">供应商信息</h3>
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="info-item">
              <span class="label">供应商名称：</span>
              <span class="value">{{ details?.supplierName }}</span>
            </div>
          </el-col>
          <!-- <el-col :span="8">
            <div class="info-item">
              <span class="label">供应商ID：</span>
              <span class="value">{{ details?.supplierId }}</span>
            </div>
          </el-col> -->
          <el-col :span="8">
            <div class="info-item">
              <span class="label">供应商地址：</span>
              <span class="value">{{ details?.address }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="info-item">
              <span class="label">联系人：</span>
              <span class="value">{{ details?.contact }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="info-item">
              <span class="label">联系电话：</span>
              <span class="value">{{ details?.contactTel }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="info-item">
              <span class="label">负责人：</span>
              <span class="value">{{ details?.charger }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="info-item">
              <span class="label">负责人电话：</span>
              <span class="value">{{ details?.chargeTel }}</span>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 备注信息 -->
      <div class="detail-section" v-if="details?.remark">
        <h3 class="section-title">备注信息</h3>
        <div class="remark-content">
          {{ details?.remark }}
        </div>
      </div>

     <!-- 审批流程 -->
     <div class="detail-section">
        <h3 class="section-title">审批流程</h3>
        <div class="flow-steps">
          <div class="flow-wrapper">
            <div v-for="node in workFlow?.nodes" 
                 :key="node.nodeId" 
                 class="flow-step"
                 :class="{ 'is-active': node.isActive, 'is-completed': node.isCompleted }">
              <!-- 步骤标题 -->
              <div class="step-header">
                <div class="step-number">{{ node.step }}</div>
                <div class="step-title">{{ node.nodeName }}</div>
                <el-tag size="mini" :type="getNodeStatusType(node.status)">
                  {{ getNodeStatusText(node.status) }}
                </el-tag>
              </div>

              <!-- 审批人列表 -->
              <div class="step-content">
                <div v-for="approver in node.approvers" 
                     :key="approver.approverId" 
                     class="approver-item">
                  <div class="approver-info">
                    <span class="approver-name">{{ approver.approverName }}</span>
                    <span class="approver-dept">({{ approver.approverDept }})</span>
                    <el-tag size="mini" :type="getApproverStatusType(approver.status)">
                      {{ getApproverStatusText(approver.status) }}
                    </el-tag>
                  </div>
                  <div class="approve-time" v-if="approver.approveTime">
                    {{ formatDateTime(approver.approveTime) }}
                  </div>
                  <span v-if="approver.remark" class="approve-comment">审核意见：{{ approver.remark }}</span>
                 </div>
              </div>

              <!-- 连接线 -->
              <div class="step-line" v-if="node.step !== workFlow?.nodes.length">
                <i class="el-icon-right" style="color: #f56c6c;"></i>
              </div>
            </div>
          </div>
        </div>
                <!-- 添加按钮组 -->
    <div class="button-container">
      <!-- 状态为已通过(4)时显示采购下单按钮 -->
      <div class="operation-buttons" v-if="plan && plan.status === 4">
        <el-button 
          type="primary" 
          @click="handleCreateOrder"
          :loading="loading">
          采购下单
        </el-button>
      </div>
    </div>
  
        
        <!-- 将按钮移到这里，添加 flex 容器 -->
        <div class="button-container">
          <div class="approve-buttons" v-if="plan && [2, 3].includes(plan.status)">
            <el-button 
              size="medium" 
              @click="handleReject"
              style="margin-right: 10px;">
              驳回
            </el-button>
            <el-button 
              size="medium" 
              type="primary" 
              @click="handleApprove">
              通过
            </el-button>
          </div>
        </div>
          
      </div>

      <!-- 备注信息 -->
      <div class="detail-section" v-if="details?.remark">
        <h3 class="section-title">备注信息</h3>
        <div class="remark-content">
          {{ details?.remark }}
        </div>
      </div>
    
    </el-card>

  

    <!-- 添加审核意见弹窗 -->
    <el-dialog
      :title="actionType === 'approve' ? '审核意见' : '驳回'"
      :visible.sync="approveDialogVisible"
      width="400px"
      :close-on-click-modal="false"
      custom-class="approve-dialog">
      <el-input
        type="textarea"
        v-model="approveComment"
        :rows="2"
        placeholder="请输入审核意见">
      </el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="approveDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitApprove">确定</el-button>
      </div>
    </el-dialog>

    <!-- 修改创建订单弹窗部分 -->
    <el-dialog
      title="生成采购订单"
      :visible.sync="createOrderVisible"
      width="500px"
      :close-on-click-modal="false">
      <el-form 
        ref="orderForm" 
        :model="orderForm" 
        :rules="orderRules" 
        label-width="80px">
        <el-form-item label="订单名称" prop="orderName">
          <el-input v-model="orderForm.orderName" placeholder="请输入订单名称"></el-input>
        </el-form-item>
        <el-form-item label="工作流" prop="workProcessID">
          <el-select 
            v-model="orderForm.workProcessID" 
            placeholder="请选择工作流"
            style="width: 100%">
            <el-option
              v-for="item in workflowOptions"
              :key="item.processId"
              :label="item.processName"
              :value="item.processId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="供应商" prop="supplierId">
          <el-select 
            v-model="orderForm.supplierId" 
            placeholder="请选择供应商"
            style="width: 100%">
            <el-option
              v-for="item in supplierOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="createOrderVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitOrder" :loading="submitLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import CreateOrder from '@/views/purchase/order/components/CreateOrder'

export default {
  name: 'PlanDetail',
  components: {
    CreateOrder
  },
  data() {
    return {
      loading: false,
      detailData: {},
      planId: this.$route.query.planId,
      plan: undefined,
      details: undefined,
      workFlow: undefined,
      approveDialogVisible: false,
      approveComment: '',
      actionType: 'approve',
      createOrderVisible: false,
      submitLoading: false,
      orderForm: {
        orderName: '',
        workflowId: '',
        supplierId: '',
        workProcessID:''
      },
      orderRules: {
        orderName: [
          { required: true, message: '请输入订单名称', trigger: 'blur' }
        ],
        workflowId: [
          { required: true, message: '请选择工作流', trigger: 'change' }
        ],
        supplierId: [
          { required: true, message: '请选择供应商', trigger: 'change' }
        ]
      },
      workflowOptions: [],
      supplierOptions: []
    }
  },
  created() {
    this.fetchDetailData()
  },
  computed: {
    // 计算总金额
    totalMoney() {
      if (!this.details) return 0
      return this.details.money || 0
    }
  },
  methods: {
     // 获取节点状态类型
     getNodeStatusType(status) {
      const typeMap = {
        1: 'primary',  // 进行中
        2: 'success',  // 已完成
        3: 'danger',   // 已拒绝
        4: 'info'      // 已取消
      }
      return typeMap[status] || 'info'
    },
      // 获取节点状态文本
      getNodeStatusText(status) {
      const statusMap = {
        1: '进行中',
        2: '已完成',
        3: '已拒绝',
        4: '已取消'
      }
      return statusMap[status] || '未知状态'
    },

    // 获取审批人状态类型
    getApproverStatusType(status) {
      const typeMap = {
        1: 'warning',  // 待处理
        2: 'primary',  // 处理中
        3: 'success',  // 已通过
        4: 'danger',   // 已拒绝
        5: 'info'      // 已转交
      }
      return typeMap[status] || 'info'
    },
    getApproverStatusText(status) {
      // 将 status 转换为数字类型，以确保正确匹配
      const statusNum = Number(status);

      const statusMap = {
        0: '未处理',
        1: '处理中',
        2: '已拒绝',
        3: '已通过',
        4: '已转交',
        5: '已回退'
      }

      // 添加调试日志
      console.log('Approver status:', status, 'Mapped status:', statusMap[statusNum]);

      return statusMap[statusNum] || '未知状态';
    },
    // 获取详情数据
    async fetchDetailData() {
      try {
        this.loading = true
        const response = await request({
          url: '/api/v1/purchasing-plan/detail',
          method: 'post',
          data: {
            planId: this.$route.query.planId
          }
        })
        
        if (response.status === 1 && response.data) {
          // 处理基本信息
          this.plan = response.data.plan

          // 处理商品和供应商信息
          const details = response.data.details
          console.log('details:', details)  // 检查数据结构

          if (details && details.list && details.list.length > 0) {  // 修改这里
            const detail = details.list[0]  // 获取第一个商品详情
            this.details = {
              // 商品信息
              goodId: detail.goodId,
              goodName: detail.goodName,
              goodModel: detail.goodModel,
              goodSpecs: detail.goodSpecs,
              number: Number(detail.number) || 0,
              price: Number(detail.price) || 0,
              money: Number(detail.money) || 0,
              
              // 供应商信息（展开到平级）
              supplierId: detail.supplierId,
              supplierName: detail.supplierName,
              address: detail.supplierInfo?.address || '',
              contact: detail.supplierInfo?.contact || '',
              contactTel: detail.supplierInfo?.contactTel || '',
              chargeTel: detail.supplierInfo?.chargeTel || '',
              charger: detail.supplierInfo?.charger || '',
              
              // 计划信息
              planId: detail.planId,
              planNo: detail.planNo,
              planName: detail.planName,
              detailId: detail.detailId,
              categoryPath: detail.categoryPath,
              
              // 时间信息
              createdAt: detail.createdAt,
              updatedAt: detail.updatedAt,
              
              // 其他信息
              remark: detail.remark || '',
              unit: detail.unit || '',
              
              // 状态信息
              status: detail.status,
              statusText: this.getStatusText(detail.status)
            }
          }

          // 处理工作流信息
          this.workFlow = response.data.workflow

          // 打印处理后的数据，用于调试
          console.log('处理后的 details:', this.details)
          console.log('处理后的 plan:', this.plan)
          console.log('处理后的 workFlow:', this.workFlow)
        } else {
          throw new Error(response.message || '获取详情失败')
        }
      } catch (error) {
        console.error('获取详情失败:', error)
        this.$message.error(error.message || '获取详情失败')
      } finally {
        this.loading = false
      }
    },

    // 格式化时间
    formatDateTime(date) {
      if (!date) return '-'
      const d = new Date(date)
      if (isNaN(d.getTime())) return '-'
      
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hour = String(d.getHours()).padStart(2, '0')
      const minute = String(d.getMinutes()).padStart(2, '0')
      const second = String(d.getSeconds()).padStart(2, '0')
      
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    },
    // 状态转换方法
    getStatusType(status) {
      const statusMap = {
        1: 'info',         // 草稿
        2: 'warning',     // 待审核
        3: 'primary',     // 审核中
        4: 'success',    // 已通过
        5: 'danger',     // 已拒绝
        6: 'info',       // 已取消
      }
      return statusMap[status] || 'info'
    },

    getStatusText(status) {
      const statusMap = {
        1: '草稿',
        2: '待审核',
        3: '审核中',
        4: '已通过',
        5: '已拒绝',
        6: '已取消'
      }
      return statusMap[status] || '未知状态'
    },

    // 表格合计行方法
    getSummaries(param) {
      const { columns } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (column.property === 'money') {
          const values = this.details ? [this.details.money] : []
          const sum = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + value
            } else {
              return prev
            }
          }, 0)
          sums[index] = '¥' + sum
        } else {
          sums[index] = ''
        }
      })
      return sums
    },

    // 处理通过按钮点击
    handleApprove() {
      this.actionType = 'approve'
      this.approveDialogVisible = true
    },

    // 处理驳回按钮点击
    handleReject() {
      this.actionType = 'reject'
      this.approveDialogVisible = true
    },

    // 提交审核
    async submitApprove() {
      if (!this.approveComment) {
        this.$message.warning('请输入审核意见')
        return
      }

      try {
        const res = await request({
          url: '/api/v1/purchasing-plan/approve',
          method: 'post',
          data: {
            planId: this.planId,
            approved: this.actionType === 'approve' ? 2 : 1, // 2-同意，1-拒绝
            comment: this.approveComment
          }
        })

        if (res.status === 1) {
          this.$message.success(this.actionType === 'approve' ? '审核通过成功' : '已驳回')
          this.approveDialogVisible = false
          // 刷新详情数据
          await this.fetchDetailData()
        } else {
          this.$message.error(res.msg || '操作失败')
        }
      } catch (error) {
        console.error('审核失败:', error)
        this.$message.error('审核失败')
      }
    },

    // 打开创建订单弹窗时获取工作流和供应商选项
    async handleCreateOrder() {
      this.orderForm = {
        planID: this.planId,
        orderName: this.plan?.planName,
        workProcessID: '',
        supplierId: '' // 清空供应商选择
      }
      this.supplierOptions = [] // 清空供应商选项
        this.createOrderVisible = true

      // 设置默认订单名称
      // this.orderForm.orderName = this.plan?.planName ? `${this.plan.planName}` : ''
      // 获取工作流选项
      await this.fetchWorkflows()
      // 获取供应商选项
      await this.fetchSuppliers()
    },

    // 获取工作流列表
    // async fetchWorkflows() {
    //   try {
    //     const res = await request({
    //       url: '/api/v1/process/by-type',
        
    //       method: 'post',
    //       data: {
    //         ...this.orderForm,
    //         planId: this.planId
    //       }
    //     })

    //     if (res.status === 1) {
    //       this.$message.success('创建订单成功')
    //       // 关闭弹窗
    //       this.createOrderVisible = false
    //       // 跳转到订单列表页面
    //       this.$router.push('/purchase/myorder')
    //     } else {
    //       throw new Error(res.msg || '创建失败')
    //     }
    //   } catch (error) {
    //     console.error('创建订单失败:', error)
    //     this.$message.error(error.message || '创建订单失败')
    //   } finally {
    //     this.submitLoading = false
    //   }
    // }
  // 获取工作流列表
  async fetchWorkflows() {
    try {
      const res = await request({
        url: '/api/v1/process/by-type',
        method: 'post',
        data: {
          code: '100003'  // 采购订单流程代码
        }
      })
      if (res.status === 1) {
        this.workflowOptions = res.data || []
      }
    } catch (error) {
      console.error('获取工作流失败:', error)
      this.$message.error('获取工作流失败')
    }
  },

  // 获取供应商列表
  // async fetchSuppliers() {
  //   try {
  //     const res = await request({
  //       url: '/api/v1/supplier/list',
  //       method: 'post',
  //       data: {
  //         page: 1,
  //         size: 1000
  //       }
  //     })
  //     if (res.status === 1) {
  //       this.supplierOptions = res.data?.list || []
  //     }
  //   } catch (error) {
  //     console.error('获取供应商失败:', error)
  //     this.$message.error('获取供应商失败')
  //   }
  // },
// 获取供应商列表
async fetchSuppliers() {
      if (this.supplierOptions.length > 0) return // 如果已经加载过就不再重复加载
      
      
      try {
        const response = await request({
          url: '/api/v1/purchasing-plan/suppliers',
          method: 'POST',
          data: {
            planId: this.orderForm.planID
          }
        })
        
        if (response.data) {
          this.supplierOptions = response.data.map(item => ({
            ...item,
            label: `${item.SupplierName}(${item.ChargeTel})`,
            value: item.SupplierID
          }))

          console.log('supplierOptions:', this.supplierOptions)
        }
      } catch (error) {
        console.error('获取供应商列表失败:', error)
        this.$message.error('获取供应商列表失败')
      } finally {
        this.isSupplierLoading = false
      }
    },






  // 提交订单
  // submitOrder() {
  //   this.$refs.orderForm.validate(async valid => {
  //     if (valid) {
  //       try {
  //         this.submitLoading = true
  //         const res = await request({
  //           url: '/api/v1/purchasing-order/create',
  //           method: 'post',
  //           data: {
  //             planId: this.planId,
  //             orderName: this.orderForm.orderName,
  //             workflowId: this.orderForm.workflowId,
  //             supplierId: this.orderForm.supplierId
  //           }
  //         })

  //         if (res.status === 1) {
  //           this.$message.success('创建订单成功')
  //           this.createOrderVisible = false
  //           // 跳转到订单列表页面
  //           this.$router.push('/purchase/myorder')
  //         } else {
  //           throw new Error(res.msg || '创建失败')
  //         }
  //       } catch (error) {
  //         console.error('创建订单失败:', error)
  //         this.$message.error(error.message || '创建订单失败')
  //       } finally {
  //         this.submitLoading = false
  //       }
  //     }
  //   })
  // }
  // 提交采购订单
  async submitOrder() {
    try {
      // 添加二次确认
      await this.$confirm('确定要生成采购订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      
      // 显示加载状态
      const loading = this.$loading({
        lock: true,
        text: '正在生成采购订单...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      
      const res = await request({
        url: '/api/v1/purchasing-order/create-from-plan',
        method: 'POST',
        data: {
          
         
          "plan_id":this.orderForm.planID,
          "order_name":this.orderForm.orderName,
          "work_flow_id":this.orderForm.workProcessID,
         "supplier_ids":[this.orderForm.supplierId]
             }
      })
      
      loading.close()
      
      if (res.status === 1) {
        this.$message.success('采购订单创建成功')
        this.createOrderVisible = false // 修正这里，之前用的是 orderDialogVisible
      // 跳转到订单列表页面
      this.$router.push('/purchase/myorder')
        // 刷新列表或其他操作
      } else {
        this.$message.error(res.msg || '创建采购订单失败')
      }
    } catch (error) {
      // 如果用户点击取消,不显示错误信息
      if (error !== 'cancel') {
        console.error('创建采购订单失败:', error)
        this.$message.error('创建采购订单失败')
      }
    }
  },

  }
}
</script>

<style lang="scss" scoped>
.plan-detail-container {
  padding: 20px;

  .page-header {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .header-left {
      display: flex;
      align-items: center;
      gap: 15px;

      .title {
        font-size: 20px;
        font-weight: 500;
      }
    }
  }

  .detail-section {
    margin-bottom: 30px;

    .section-title {
      font-size: 16px;
      font-weight: 500;
      color: #303133;
      margin-bottom: 20px;
      padding-left: 10px;
      border-left: 4px solid #409EFF;
    }

    .info-item {
      margin-bottom: 15px;
      
      .label {
        color: #606266;
        margin-right: 10px;
      }

      .value {
        color: #303133;
        &.money {
          color: #f56c6c;
          font-weight: 500;
        }
      }
    }

    .remark-content {
      padding: 15px;
      background-color: #f5f7fa;
      border-radius: 4px;
      color: #606266;
      line-height: 1.6;
    }
  }
}

.flow-steps {
  display: flex;
  align-items: stretch;
  padding: 20px 0;
  overflow-x: auto;

  .flow-wrapper {
    display: flex;
    flex: 1;
    align-items: stretch;
  }

  .flow-step {
    flex: 1;
    min-width: 250px;
    position: relative;
    padding: 0 20px;
    display: flex;
    flex-direction: column;

    &.is-completed {
      .step-number {
        background-color: #67C23A;
      }
    }

    &.is-active {
      .step-number {
        background-color: #409EFF;
      }
    }

    .step-header {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      
      .step-number {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background-color: #909399;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
        font-size: 14px;
      }

      .step-title {
        font-weight: 500;
        margin-right: 10px;
      }
    }

    .step-content {
      flex: 1;
      background: #f8f9fa;
      border-radius: 4px;
      padding: 15px;
      height: 100%;
      box-sizing: border-box;

      .approver-item {
        padding: 10px 0;
        border-bottom: 1px dashed #EBEEF5;

        &:last-child {
          border-bottom: none;
          padding-bottom: 0;
        }

        &:first-child {
          padding-top: 0;
        }

        .approver-info {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 5px;

          .approver-name {
            font-weight: 500;
          }

          .approver-dept {
            color: #909399;
            font-size: 12px;
          }
        }

        .approve-time {
          font-size: 12px;
          color: #909399;
          margin-bottom: 5px;
        }

        .approve-comment {
          font-size: 13px;
          color: #606266;
          background: #fff;
          padding: 1px;
          border-radius: 4px;
        }
      }
    }

    .step-line {
      position: absolute;
      top: 12px;
      right: -10px;
      color: #DCDFE6;
      font-size: 20px;
      z-index: 1;
    }
  }
}

// 适配移动端
@media screen and (max-width: 768px) {
  .flow-steps {
    flex-direction: column;
    
    .flow-step {
      width: 100%;
      margin-bottom: 20px;
      
      .step-line {
        transform: rotate(90deg);
        right: 50%;
        top: auto;
        bottom: -25px;
      }
    }
  }
}

// 修改按钮容器样式
.button-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #EBEEF5;

  .operation-buttons {
    display: flex;
    gap: 10px;
  }
}

// 修改按钮组样式
.approve-buttons {
  // 移除 fixed 定位相关样式
  padding: 0;
  background-color: transparent;
  box-shadow: none;
}

// 移除之前的 padding-bottom
.app-container {
  padding-bottom: 0;
}

// 审核弹窗样式
.approve-dialog {
  :deep(.el-dialog__body) {
    padding: 20px;
  }

  :deep(.el-textarea__inner) {
    border-radius: 4px;
  }
}

/* 创建订单弹窗样式 */
.create-order-dialog {
  :deep(.el-dialog__body) {
    padding: 20px;
  }
}
</style> 